export const PersonalLoc = {
    pageTitle: {
        ru: 'Личный кабинет',
        en: 'Personal area',
    },
    notSpecified: {
        ru: 'не указан',
        en: 'not specified',
    },
    rub: {
        ru: 'руб',
        en: 'rub',
    },
    accountBalance: {
        ru: 'Остаток на счету',
        en: 'Account balance',
    },
    more: {
        ru: 'еще',
        en: 'more',
    },
    rentdays: {
        ru: 'арендодней',
        en: 'rentdays',
    },
    personal: {
        savedMoney: {
            ru: 'Cэкономлено благодаря программе лояльности',
            en: 'Saved by Loyalty Program',
        },
        lowerRate: {
            ru: 'Ниже арендная ставка по сравнению с прайсом',
            en: 'Lower rental rate compared to price',
        },
        points: {
            ru: 'Баллов',
            en: 'Points',
        },
        pointsInfo: {
            ru:
                'Информация о том, как начисляются баллы. Например, зак каждый арендодень вы получаете 1 балл. 1 балл стоит 1часу аренды. Вы можете использовать накопленные баллы для аренды оборудования. Выберите необходимую технику и свяжитесь с менеджером для использования подарочных дней.',
            en:
                'Information on how points are awarded. For example, zak each rental day you get 1 point. 1 point costs 1 hour of rental. You can use the accumulated points to rent equipment. Choose the necessary equipment and contact the manager to use the gift days.',
        },
        accumulatedPoints: {
            ru: 'Накопленные баллы',
            en: 'Accumulated points',
        },
        yourDiscountOn: {
            ru: 'Ваша скидка на',
            en: 'Your discount on',
        },
        totalRentdaysAt: {
            ru: 'Всего арендодней за',
            en: 'Total rental at',
        },
        upcomingMaintenance: {
            ru: 'Предстоящее ТО',
            en: 'Upcoming maintenance',
        },
        signUpToMaintenance: {
            ru: 'Записаться на ТО',
            en: 'Sign up for maintenance',
        },
        work: {
            ru: 'ч. работы',
            en: 'h. work',
        },
        lastOrders: {
            ru: 'Последние заказы',
            en: 'Last orders',
        },
        allOrdersButton: {
            ru: 'Все заказы',
            en: 'All orders',
        },
        rentPersonalOffers: {
            ru: 'Персональные предложения, аренда',
            en: 'Personal offers, rent',
        },
        allOffersButton: {
            ru: 'Все предложения',
            en: 'All offers',
        },
        useRentTitle: {
            ru: 'Используйте Накопленные баллы',
            en: 'Use Accumulated Points',
        },
        useRentDetails: {
            0: {
                ru: 'Вы можете использовать накопленные баллы для аренды оборудования.',
                en: 'You can use the accumulated points to rent equipment.',
            },
            1: {
                ru: 'Выберите необходимую технику и свяжитесь с менеджером для использования подарочных дней.',
                en: 'Choose the necessary equipment and contact the manager to use the gift days.',
            },
        },
        monthSales: {
            ru: 'Скидки месяца',
            en: 'Monthly discounts',
        },
        allDiscountsButton: {
            ru: 'Все скидки',
            en: 'All discounts',
        },
        nextDiscount: {
            ru: 'Будущая скидка',
            en: 'Next discount',
        },
    },
    leftCol: {
        personalManager: {
            ru: 'Персональный менеджер',
            en: 'Personal manager',
        },
        workingHours: {
            ru: 'Время работы',
            en: 'Working hours',
        },
        write: {
            ru: 'Написать',
            en: 'Write',
        },
        managerNotFound: {
            title: {
                ru: 'Менеджер пока не подключен к вашему аккаунту.',
                en: 'The Manager is not yet connected to your account.',
            },
            text: {
                ru: 'Подождите несколько дней или обратитесь в поддержку.',
                en: 'Wait a bit or contact support.',
            },
        },
    },
    menu: {
        catalog: {
            ru: 'Каталог',
            en: 'Catalog',
        },
        personalArea: {
            ru: 'Личный кабинет',
            en: 'Personal area',
        },
        orders: {
            ru: 'Мои заказы',
            en: 'My orders',
        },
        order: {
            ru: 'Заказ',
            en: 'Order',
        },
        favorites: {
            ru: 'Избранное',
            en: 'Favorites',
        },
        sales: {
            ru: 'Мои скидки',
            en: 'My sales',
        },
        profile: {
            ru: 'Мой профиль',
            en: 'My profile',
        },
        chat: {
            ru: 'Чат с менеджером',
            en: 'Chat with the manager',
        },
        tech: {
            ru: 'Тех. служба',
            en: 'Technical service',
        },
        instructions: {
            ru: 'Инструкции',
            en: 'Instructions',
        },
        exit: {
            ru: 'Выход',
            en: 'Logout',
        },
    },
};
